import React, { useState } from 'react';
import { Dropdown } from 'rsuite';
import { ImCross } from 'react-icons/im';
import DropdownOverlay from '../DropdownOverlay';
import CrossDockForceDispatchResultDialog from './CrossDockForceDispatchResultDialog';
import { forceDispatchCrossDock } from '../../api/crossdock/crossDock';
import { ForceDispatchCrossDockResponse } from '../../api/crossdock/crossDockTrackingTypes';

interface Props {
  orderId: number;
}

export default function CrossDockIcon({ orderId }: Props) {
  const [dispatchResult, setDispatchResult] = useState<ForceDispatchCrossDockResponse>();

  async function handleDispatch(relabel: boolean) {
    const result = await forceDispatchCrossDock({ orderId, relabel });
    setDispatchResult(result);
  }

  return (
    <>
      <DropdownOverlay
        element={(
          <span style={{ cursor: 'pointer' }}>
            <ImCross />
          </span>
      )}
      >
        <Dropdown.Menu>
          <Dropdown.Item
            onClick={() => handleDispatch(true)}
          >
            Send data to cross dock as relabel
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => handleDispatch(false)}
          >
            Send data to cross dock as consolidated
          </Dropdown.Item>
        </Dropdown.Menu>
      </DropdownOverlay>
      <CrossDockForceDispatchResultDialog
        result={dispatchResult}
        onClose={() => setDispatchResult(undefined)}
      />
    </>
  );
}
